import { render, staticRenderFns } from "./AddLearners.vue?vue&type=template&id=54c2a842&scoped=true&"
import script from "./AddLearners.vue?vue&type=script&lang=js&"
export * from "./AddLearners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2a842",
  null
  
)

export default component.exports